import Link from 'next/link';
import type { AnchorHTMLAttributes } from 'react';

/**
 * 내부 이동은 `Link`, 나머지는 생 `<a>` (2026-08-22 UX 채택안 #2).
 *
 * 지금까지 전부 생 `<a>` 라 **클릭마다 페이지를 통째로 다시 받았다**(흰 화면·스크롤 위치 상실).
 * `Link` 는 마우스를 올린 순간 다음 화면을 미리 받아 두어 클릭 즉시 전환된다.
 *
 * 생 `<a>` 로 남겨야 하는 것들 —
 *  · 외부 주소(http…)·mailto·tel — Link 가 관여할 일이 없다
 *  · `/api/…` — BFF 라우트(소셜 로그인 진입 등). 클라 전환이 아니라 서버 왕복이어야 한다
 *  · `/logout` — 로그아웃 뒤에는 풀 리로드로 클라이언트 상태를 통째로 비우는 것이 맞다
 *
 * 메뉴처럼 **주소가 데이터에서 오는 자리**는 내부/외부가 섞여 있으므로 반드시 이걸 쓴다.
 */
const RAW = [/^https?:/i, /^\/api\//, /^\/logout\b/, /^mailto:/i, /^tel:/i];

export function SmartLink({ href = '', children, ...rest }: AnchorHTMLAttributes<HTMLAnchorElement>) {
  if (!href.startsWith('/') || RAW.some((re) => re.test(href))) {
    return <a href={href} {...rest}>{children}</a>;
  }
  return <Link href={href} {...rest}>{children}</Link>;
}
